import React from 'react';

import {Overhang} from 'biojs/Sequence';
import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface FragmentRowProps {
  start: number;
  end: number;
  length: number;
  leftCutterName: string;
  leftCutterOverhang: Overhang;
  rightCutterName: string;
  rightCutterOverhang: Overhang;
}

function FragmentRow({
  start,
  end,
  length,
  leftCutterName,
  leftCutterOverhang,
  rightCutterName,
  rightCutterOverhang,
}: FragmentRowProps): JSX.Element {
  return (
    <>
      <td {...getTestProps({component: 'FragmentRow', element: 'start'})}>{start}</td>
      <td>{end}</td>
      <td>{length}</td>
      <td>{leftCutterName}</td>
      <td>{leftCutterOverhang}</td>
      <td>{rightCutterName}</td>
      <td>{rightCutterOverhang}</td>
    </>
  );
}

export default makeDeprecatedJadeStyleTemplate<FragmentRowProps>(FragmentRow);
